(function () {
	'use strict';

	var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
	var stickyfill = require('stickyfill')();

	var runSticky = function () {
		stickyfill.kill();

		$('.sticky').each(function () {
			stickyfill.add(this);
		});

		if (window.matchMedia('(min-width: 760px)').matches) {
			$('.sticky--bp-medium').each(function () {
				stickyfill.add(this);
			});
		}

		if (window.matchMedia('(min-width: 1020px)').matches) {
			$('.sticky--bp-large').each(function () {
				stickyfill.add(this);
			});
		}

		stickyfill.init();
	};

	runSticky();

	$(window).on('resize', function () {
		runSticky();
	});
})();
